import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Capitalize, Icon, Text } from '../../../../../components';

const TermTranslationsItemContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const BoldText = styled(Text)`
  font-weight: 600;
  line-height: 20px;
`;

const StyledIcon = styled(Icon)`
  vertical-align: bottom;
  margin-right: 2px;
`;

const TermTranslationsItem = ({ termList, description, className = null }) => (
  <TermTranslationsItemContainer className={className}>
    <Text>
      <StyledIcon name='information' color='var(--content-subtitle)' displaySize={20} />
      {termList[0] !== '*' && (
        <BoldText as='span'>
          <Capitalize string={termList[0]} />
          {': '}
        </BoldText>
      )}
      {description}
    </Text>
  </TermTranslationsItemContainer>
);

TermTranslationsItem.propTypes = {
  termList: PropTypes.arrayOf(PropTypes.string).isRequired,
  description: PropTypes.string.isRequired,
  className: PropTypes.string
};

export { TermTranslationsItem };
